import React from "react"

const Sunset = () => (
  <div
    style={{
      minHeight: "100vh",
      width: "100vw",
      background: "#0a2328 url('sunset_bg.png') right center no-repeat",
      backgroundSize: "cover",
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      fontFamily: "Roboto, serif",
    }}
  >
    <div
      className="mx-4 mx-sm-5 mx-md-6 mx-xl-8"
      style={{
        maxWidth: 700,
        color: "#fff",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", marginBottom: 32 }}>
        <img
          src="/logo.svg"
          alt="Powerdot TV Logo"
          style={{ height: 48, width: "auto", marginBottom: 0 }}
        />
      </div>
      <div
        style={{
          fontWeight: 700,
          fontSize: 20,
          lineHeight: "24px",
          marginBottom: 24,
        }}
      >
        {window.strings.sunset.content_1}
      </div>
      <div
        style={{
          fontSize: 14,
          fontWeight: 400,
          lineHeight: "18px",
          color: "#dbe6e9",
          marginBottom: 20,
        }}
      >
        {window.strings.sunset.content_2}
      </div>
      <div
        style={{
          fontSize: 14,
          fontWeight: 400,
          lineHeight: "18px",
          color: "#dbe6e9",
        }}
      >
        {window.strings.sunset.content_3}{" "}
        <a
          href={`mailto:${window.strings.sunset.email}`}
          style={{ color: "#00b6e6", textDecoration: "underline" }}
        >
          {window.strings.sunset.email}
        </a>{" "}
        — {window.strings.sunset.content_4}
      </div>
    </div>
  </div>
)

export default Sunset
